<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<nz-spin [nzSpinning]="isSaving">
  <form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()" *transloco="let tr; prefix: 'stores'; scope: 'stores'">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('property.form.key')}}</nz-form-label>
          <nz-select [nzDisabled]="isEdit" formControlName="key">
            <nz-option *ngFor="let key of allKeys" [nzValue]="key.title" [nzLabel]="key.title"></nz-option>
          </nz-select>
        </nz-form-item>
      </div>

      <div nz-col>
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('property.form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="enabled">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-3">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('property.form.value')}}</nz-form-label>
          <nz-form-control>
            <textarea [readonly]="form.controls.key.value === 'store-info'" rows="4" nz-input formControlName="value"></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div *ngIf="form.controls.key.value === 'store-info'" nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <hc-store-info-form [formInfo]="form.controls.value.value" (formInfoChange)="onFormChanged($event)"></hc-store-info-form>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && prop?.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-spin>
